// @flow
import React from 'react';
import { escapeForUrl } from 'lib/common';
import './CategoryMenuBoxItem.scss';

type Props = {
  name: string,
  count: number,
  history: Object,
  closeMenuBox: Function,
};

const CategoryMenuBoxItem = ({ name, count, history, closeMenuBox }: Props) => {
  const moveToSubItemPage = () => {
    closeMenuBox();
    history.push(`/categories/${escapeForUrl(name)}`);
  };

  return (
    <div className="CategoryMenuBoxItem" onClick={moveToSubItemPage}>
      <div className="name">{name}</div>
      <div className="counts">{count}</div>
    </div>
  );
};

export default CategoryMenuBoxItem;



// WEBPACK FOOTER //
// ./src/components/categories/CategoryMenuBoxItem/CategoryMenuBoxItem.js